export function getShortMonthKey(month: number): string {
  return `short_month_key_${month}`;
}

export function getLongMonthKey(month: number): string {
  return `long_month_key_${month}`;
}
